export type ApiRequestInit = RequestInit & { json?: unknown };

export async function apiFetch<T>(input: RequestInfo | URL, init: ApiRequestInit = {}): Promise<T> {
  const headers = new Headers(init.headers);
  headers.set('Accept', 'application/json');
  if (init.json !== undefined) {
    headers.set('Content-Type', 'application/json');
    init.body = JSON.stringify(init.json);
  }
  const response = await fetch(input, { ...init, headers, credentials: 'include' });
  const contentType = response.headers.get('content-type') ?? '';
  const body = contentType.includes('application/json') ? await response.json() : await response.text();
  if (!response.ok) {
    const detail = typeof body === 'object' && body && 'detail' in body ? String((body as { detail: unknown }).detail) : `HTTP ${response.status}`;
    const error = new Error(detail) as Error & { status?: number };
    error.status = response.status;
    throw error;
  }
  return body as T;
}

export type AuthUser = { id: string; open_id: string; email: string | null; display_name: string };

export const authApi = {
  me: () => apiFetch<{ authenticated: boolean; user?: AuthUser }>('/api/v1/auth/me'),
  login: () => { window.location.assign('/api/v1/auth/login'); },
  logout: () => apiFetch<{ ok: boolean }>('/api/v1/auth/logout', { method: 'POST' }),
};
